import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { NavService } from '../../_services/_nav.service';
import { Sistema } from '../../_models/sistema';
import { SistemaService } from '../../_services/sistema.service';

@Component( {
  selector: 'app-sistema-editar',
  templateUrl: 'sistema-editar.component.html'
} )

export class SistemaEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  tokExiste = false;
  guardando = false;
  sistema: Sistema;
  lisSistemas: Sistema[] = [];
  formulario: FormGroup;
  submitted = false;

  constructor( private sisServicio: SistemaService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private navServicio: NavService ) {
  }

  ngOnInit(): void {

    this.route.params.subscribe( ( params: Params ) => {
      this.sisServicio.getAll().subscribe( sistemas => {
        this.lisSistemas = sistemas;
        if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
          this.sisServicio.getById( params[ 'id' ] ).subscribe( sistema => {
            this.sistema = sistema;
            this.carServiciosIniciales();
          } );
        } else {
          this.carServiciosIniciales();
        }
      } );
    } );
  }

  carServiciosIniciales() {
    this.formulario = this.fb.group( {
      idSistema: [ this.sistema ? this.sistema.idSistema : null ],
      codigo: [ this.sistema ? this.sistema.codigo : null, [ Validators.required, Validators.maxLength( 10 ) ] ],
      nombreSistema: [ this.sistema ? this.sistema.nombreSistema : null, [ Validators.required, Validators.maxLength( 20 ) ] ],
      descripcion: [ this.sistema ? this.sistema.descripcion : null, [ Validators.maxLength( 250 ) ] ],
      token: [ this.sistema ? this.sistema.token : null, [ Validators.required, Validators.maxLength( 50 ) ] ],
      indicadorCreacion: [ this.sistema ? this.sistema.indicadorCreacion : false ],
      indicadorHabilitado: [ this.sistema ? this.sistema.indicadorHabilitado : true ],
      indicadorConsulta: [ this.sistema ? this.sistema.indicadorConsulta : false ],
      indicadorActualizacion: [ this.sistema ? this.sistema.indicadorActualizacion : false ],
      auditoriaUsuario: [ this.sistema ? this.sistema.auditoriaUsuario : null ],
      auditoriaFecha: [ this.sistema ? this.sistema.auditoriaFecha : null ],
    } );
    this.carInformacionInicial = false;
  }

  onSubmit() {
    this.submitted = true;
    if ( !this.codExiste && !this.tokExiste && this.formulario.valid ) {
      this.guardando = true;
      const sistema = this.formulario.value;
      if ( sistema.idControl ) {
        this.sisServicio.update( sistema ).subscribe( rta => {
          this.navServicio.setMesage( 2 );
          this.guardando = false;
          this.location.back();
        }, error => {
          this.navServicio.setMesage( 3 );
          this.guardando = false;
        } );
      } else {
        this.sisServicio.add( sistema ).subscribe( rta => {
          sistema.idSistema = rta && rta.idSistema ? rta.idSistema : sistema.idSistema;
          this.f.idSistema.setValue( rta && rta.idSistema ? rta.idSistema : sistema.idSistema );
          this.navServicio.setMesage( 1 );
          this.guardando = false;
          this.location.back();
        }, error => {
          this.navServicio.setMesage( 3 );
          this.guardando = false;
        } );
      }
    }
  }


  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  validarCodigo() {
    this.codExiste = this.lisSistemas.find( x => x.codigo && this.f.codigo.value && x.codigo.toLowerCase() === this.f.codigo.value.toLowerCase() ) ? true : false;
  }

  validarToken() {
    this.tokExiste = this.lisSistemas.find( x => x.token === this.f.token.value && (!this.sistema || this.sistema.idSistema !== x.idSistema) ) ? true : false;
  }

  get f() {
    return this.formulario.controls;
  }
}
